import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class PlainHtml extends Component {
  componentDidMount() {
    this.setContent();
  }

  shouldComponentUpdate({ content }) {
    return content !== this.props.content;
  }

  componentDidUpdate() {
    this.setContent();
  }

  setContent = () => {
    this.container.innerHTML = this.props.content; //eslint-disable-line
  };

  render() {
    return (
      <div ref={(ref) => { this.container = ref; }} />
    );
  }
}

PlainHtml.propTypes = {
  content: PropTypes.string
};
